const { default: getFrontConfig } = require('../getFrontConfig');

const DISPATCHER_COOKIE_NAME = 'dispatcher';
const IGNORE_GEOLOCATION_COOKIE_NAME = 'ignoreGeolocation';

/**
* Delete dispatcher cookie
* @param {string} cookieName
*/
function deleteCookie(cookieName) {
  const expiredTime = 'Thu, 01 Jan 1970 00:00:00 UTC';
  document.cookie = `${cookieName}=;path=/;expires=${expiredTime}`;
}

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) === ' ') {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return '';
}

/**
 * Get the country & language data from the dispatcher cookie
 * @returns {Object} country and language info from the dispatcher cookie
 */
function getDataFromDispatcherCookie() {
  const dispatcherCookieValue = getCookie(DISPATCHER_COOKIE_NAME);
  if (dispatcherCookieValue.length > 0) {
    const info = dispatcherCookieValue.replaceAll('"', '').split(',');
    const countryCode = info[0].toUpperCase();
    const languageCode = info[1].toUpperCase();
    return {
      country: countryCode,
      lang: languageCode,
    };
  }

  return {};
}

/**
 * It sets a cookie with the given name and value, and with the given max age
 * @param {string} cookieName - The name of the cookie to set.
 * @param {string} cookieValue - The value of the cookie.
 * @param {number} cookieMaxAge - The duration of the cookie in seconds.
 * @returns {Boolean} true if cookie data is ok, false otherwise
 */
function setCookie(cookieName, cookieValue, cookieMaxAge) {
  if (cookieName && cookieValue) {
    const maxAge = `max-age=${cookieMaxAge || getFrontConfig()?.dispatcherCookieDuration}`;
    document.cookie = `${cookieName}="${cookieValue}";path=/;${maxAge};secure`;
    return true;
  }
  return false;
}

/**
 * Set dispatcherCookie for country and lang params
 * @param {string} country country code
 * @param {string} lang language code
 * @returns {null|boolean} null if no country or lang is provided, otherwise true
 */
function setDispatcherCookie(country, lang) {
  if (!country || !lang) return null;
  const cookieValue = `${country.toLowerCase()},${lang.toLowerCase()}`;
  const maxAge = getFrontConfig()?.dispatcherCookieDuration;
  return setCookie(DISPATCHER_COOKIE_NAME, cookieValue, maxAge);
}

module.exports = {
  names: {
    DISPATCHER_COOKIE_NAME,
    IGNORE_GEOLOCATION_COOKIE_NAME,
  },
  deleteCookie,
  getCookie,
  getDataFromDispatcherCookie,
  setCookie,
  setDispatcherCookie,
};
